export default "__VITE_ASSET__BWDh$TWw__"